import { render, staticRenderFns } from "./publishing-details.vue?vue&type=template&id=a83267f6"
import script from "./publishing-details.vue?vue&type=script&lang=js"
export * from "./publishing-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports